<app-navbar></app-navbar>    

<div id="main-content" class="animated fadeIn">
    <div class="container-fluid">

    <!-- contenido-->
    <div class="block-header">
        <div class="row clearfix">
            <div class="col-md-6 col-sm-12">
                <h1 class="color">Calendario</h1>
                <div class="header">
                    <p style="cursor: pointer;" class="color"><i class="fa fa-angle-left " style="font-size: 19px;" aria-hidden="true"></i> Gestor de Tareas / <span class="" style="color: #a5a8ad;">Calendario</span></p>
                </div>
            </div>            
            
        </div>
       
    </div>

    <div class="row">
      <div class="card">
        <div class="body">
          <form method="POST" #addForm="ngForm" (ngSubmit)="onSubmit(addForm)" style="width: 100%;">
            <div class="row">
              <div class="col-md-4">
                <label for="staticEmail2" style="float: right; margin: 0px;">Ver calendario por proyecto: </label>
              </div>
              <div class="col-md-4">
                
                  <select class="selectpicker form-control"   [(ngModel)]="tarea.tarea" name="users" data-style="btn-info" data-size="6" data-show-subtext="true" data-live-search="true" title="Seleccia el proyecto" required>
                    <option *ngFor="let agrega of agregar_usuario" value="{{agrega.id}}" >{{agrega.categoria}}</option>
                  </select>
                  
                </div>
                <div class="col-md-4">
                   <button type="submit" class="btn btn-primary mb-2 btn-round" [disabled]="!addForm.form.valid">Guardar</button>
               </div>
            </div>
            </form>
        </div>
      </div>
    </div>
      



    <div class="row">
            <div class="col-sm-12 " [ngClass]="{ 'col-md-12 col-lg-12':!ver_info, 'col-md-7 col-lg-7':ver_info }">

    <div class="row text-center">



        <div class="col-md-4">
          <div class="btn-group">
            <div
              class="btn btn-primary"
              mwlCalendarPreviousView
              [view]="view"
              [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()"
            >
              Anterior
            </div>
            <div
              class="btn btn-outline-secondary"
              mwlCalendarToday
              [(viewDate)]="viewDate"
            >
              Hoy
            </div>
            <div
              class="btn btn-primary"
              mwlCalendarNextView
              [view]="view"
              [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()"
            >
              Siguiente
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'es' }}</h3>
        </div>
        <!-- <div class="col-md-4">
          <div class="btn-group">
            <div
              class="btn btn-primary"
              (click)="setView(CalendarView.Month)"
              [class.active]="view === CalendarView.Month"
            >
              Mes
            </div>
            <div
              class="btn btn-primary"
              (click)="setView(CalendarView.Week)"
              [class.active]="view === CalendarView.Week"
            >
              Semana
            </div>
            <div
              class="btn btn-primary"
              (click)="setView(CalendarView.Day)"
              [class.active]="view === CalendarView.Day"
            >
              Día
            </div>
          </div>
        </div> -->
      </div>
      <br />
      <div [ngSwitch]="view">
        <mwl-calendar-month-view
        
          *ngSwitchCase="CalendarView.Month"
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          [activeDayIsOpen]="activeDayIsOpen"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-month-view>
        <!-- <mwl-calendar-week-view
        
          *ngSwitchCase="CalendarView.Week"
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-week-view>
        <mwl-calendar-day-view
        
          *ngSwitchCase="CalendarView.Day"
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-day-view> -->
      </div>
      
     
      
      <ng-template #modalContent let-close="close">
        <div class="modal-header">
          <h5 class="modal-title">Event action occurred</h5>
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            Action:
            <pre>{{ modalData?.action }}</pre>
          </div>
          <div>
            Event:
            <pre>{{ modalData?.event | json }}</pre>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">
            OK
          </button>
        </div>
      </ng-template>











   

        <!-- end contenido-->
    </div>
    <div class="col-sm-12 col-md-5 col-lg-5" *ngIf="ver_info"  style="overflow-y:scroll; height:600px; scrollbar-width: none;">    
        <app-info [info]="ver_tarea" (cerrarInfo)="cerrarInfo()"></app-info>
      </div>
     </div>
   
</div>

</div>